import SimpleSnackbar from './SimpleSnackbar'
export default SimpleSnackbar
